import balloons from '../../images/balloons.jpeg'
import balloons2 from '../../images/balloonsSmall.jpeg'
import styles from './PartyEvents.module.css'
import newBallons from '../../images/newballoons2.svg'
import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Browser } from '@capacitor/browser';
import { setLogoutRequested } from '../currentPartyEvent/currentPartyEventSlice';
import { callbackUri } from '../../AppSettings';
import { FrontScreenBalloons } from '../../images/SvgImages';

export function NotLoggedInScreen () {

    const { loginWithRedirect, isAuthenticated, logout, user } = useAuth0();
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const login = async () => {
        await loginWithRedirect({
          
          async openUrl(url) {
            await Browser.open({
              url,
              windowName: "_self"
            });
          }
        });
      };
    const doLogout = async () => {
        dispatch(setLogoutRequested(true))
        await logout({
          async openUrl(url) {
            await Browser.open({
              url,
              windowName: "_self",
            });
          },
          logoutParams: {
            returnTo: callbackUri
          }
        });
      };
    return (
        <div className={styles.loggedOutContainer}>
            <h1>PartyPlanner</h1>
                <h2> Log in to continue</h2>
        <div>
            <button className={styles.login} onClick={login}>
                Login
            </button>
        </div>
        <br></br>
        <div>
        <FrontScreenBalloons/>
        </div>
        </div>
    )
}
